/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Surface_Dock_Restore_AllInputs */

const en_surface_dock_restore_all = /** @type {(inputs: Surface_Dock_Restore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore all`)
};

const ar_surface_dock_restore_all = /** @type {(inputs: Surface_Dock_Restore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استعادة الكل`)
};

const bn_surface_dock_restore_all = /** @type {(inputs: Surface_Dock_Restore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সব পুনরুদ্ধার করুন`)
};

const de_surface_dock_restore_all = /** @type {(inputs: Surface_Dock_Restore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle wiederherstellen`)
};

const es_surface_dock_restore_all = /** @type {(inputs: Surface_Dock_Restore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar todo`)
};

const fr_surface_dock_restore_all = /** @type {(inputs: Surface_Dock_Restore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout restaurer`)
};

const pt_surface_dock_restore_all = /** @type {(inputs: Surface_Dock_Restore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar tudo`)
};

const zh_surface_dock_restore_all = /** @type {(inputs: Surface_Dock_Restore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部恢复`)
};

const tr_surface_dock_restore_all = /** @type {(inputs: Surface_Dock_Restore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tümünü geri yükle`)
};

const ru_surface_dock_restore_all = /** @type {(inputs: Surface_Dock_Restore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Восстановить все`)
};

const pl_surface_dock_restore_all = /** @type {(inputs: Surface_Dock_Restore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przywróć wszystkie`)
};

/**
* | output |
* | --- |
* | "Restore all" |
*
* @param {Surface_Dock_Restore_AllInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const surface_dock_restore_all = /** @type {((inputs?: Surface_Dock_Restore_AllInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Surface_Dock_Restore_AllInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_surface_dock_restore_all(inputs)
	if (locale === "bn") return bn_surface_dock_restore_all(inputs)
	if (locale === "de") return de_surface_dock_restore_all(inputs)
	if (locale === "es") return es_surface_dock_restore_all(inputs)
	if (locale === "fr") return fr_surface_dock_restore_all(inputs)
	if (locale === "pt") return pt_surface_dock_restore_all(inputs)
	if (locale === "zh") return zh_surface_dock_restore_all(inputs)
	if (locale === "tr") return tr_surface_dock_restore_all(inputs)
	if (locale === "ru") return ru_surface_dock_restore_all(inputs)
	if (locale === "pl") return pl_surface_dock_restore_all(inputs)
	return en_surface_dock_restore_all(inputs)
});